import React from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import Headline from "../../atoms/headline";
import { object } from "prop-types";
import CardImage from "../../atoms/card-image";
import "./also-read.m.css";

const AlsoRead = ({ story, element }) => {
  const linkedStoryId = get(element, ["metadata", "linked-story", "id"], "");
  const linkedStory = get(story, ["linked-stories", linkedStoryId], {});
  const linkedStorySlug = get(story, ["linked-stories", linkedStoryId, "slug"], "");
  const linkedStoryHeadline = get(story, ["linked-stories", linkedStoryId, "headline"], element.text);
  return (
    <Link href={`/${linkedStorySlug}`} styleName="wrapper">
      {linkedStory["hero-image-s3-key"] && (
        <div styleName="image">
          <CardImage story={linkedStory} defaultWidth={200} aspectRatio={[16, 9]} imageType="image16x9" />
        </div>
      )}
      <div styleName="content">
        <p styleName="read-more">Also Read</p>
        <Headline text={linkedStoryHeadline} headerType={11} headerLevel={4} />
      </div>
    </Link>
  );
};

AlsoRead.propTypes = {
  story: object,
  element: object
};

export default AlsoRead;
